import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { TabView, TabPanel } from 'primereact/tabview';
import {
    WHITE_FONT_COLOR,
    TITLE_FONT_COLOR,
    GRAY_FONT_COLOR,
   BORDER_COLOR,
    DARK_BORDER_COLOR,
} from 'src/styles/fonts/MCFontConstants';

export const StyledTabView = styled(TabView).attrs(({ id }) => ({
    id: id || 'tab-control-tabview'
}))`
    .p-tabview-nav {
        display: flex;
        justify-content: stretch;
        overflow: hidden;
        white-space: nowrap;
         width: ${({ tabViewWidth}) => tabViewWidth ? tabViewWidth : ''};
        height: ${({ tabViewHeight }) => tabViewHeight};
        margin: ${({ tabViewMargin }) => tabViewMargin};
        margin-top: ${({marginTop}) => marginTop ? marginTop : ''};
        margin-bottom: ${({marginBottom}) => marginBottom ? marginBottom : ''};
        padding-top : ${(paddingTop) => paddingTop};
        padding-bottom : ${(paddingBottom) => paddingBottom};
        background: ${({ backgroundColor }) => backgroundColor ? backgroundColor : 'none'};
        border: ${({ border }) => (border ? border : 'none')};
        border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '6px')};

        ${media.largeDevice`
            width: ${({ tabViewWidthLargeDevice }) => tabViewWidthLargeDevice};
        `}

        ${media.mediumDevice`
            width: ${({ tabViewWidthMediumDevice }) => tabViewWidthMediumDevice};
        `}
        ${media.mobileDevice`
            width: ${({widthForMobileScreen}) =>
                widthForMobileScreen
                    ? widthForMobileScreen
                    : '100% !important'};
            border: 1px solid ${DARK_BORDER_COLOR} !important;
        `}
                
        li {
            width: ${({tabWidth}) => tabWidth ? `${tabWidth} !important` : '50% !important'};
            height: 100% !important;
            flex-grow: ${({flexGrow}) => (flexGrow ? 1 : 0)};
            a{
                background-color: ${({ activeBGColor }) =>
                    activeBGColor ? activeBGColor : `${WHITE_FONT_COLOR} !important`};
                border-radius: 0px !important;
                padding:${({dkPadding}) =>
                    dkPadding ? dkPadding : '0 !important'};
                height: 100%;
                width: 100%;
                margin: 0 !important;
                display: flex;
                align-items: center;
                justify-content: ${({dkJustifyContent}) =>
                    dkJustifyContent ? dkJustifyContent : 'center'};
                span {
                    font-family: ${({ tabFontFamily }) => tabFontFamily};
                    font-size: ${({ tabFontSize }) => tabFontSize};
                    color: ${({ tabFontColor }) => tabFontColor};
                    white-space: ${({ whiteSpace }) => whiteSpace};
                    padding: ${({ isCondensedView }) => isCondensedView ? '0' : '0 5px'};
                }
            }
        }

        li:not(.p-highlight) {
            a {
                background-color: ${({ disabledBGcolor }) =>
                    disabledBGcolor
                        ? disabledBGcolor
                        : `${BORDER_COLOR} !important`};
                span {
                    color: ${({ inactiveTabFontColor }) => inactiveTabFontColor || GRAY_FONT_COLOR};
                }
            }
        }

        li{
            border-right:  1px solid ${DARK_BORDER_COLOR};
        }

        li:nth-last-child(2){
            border-right: none;
        }
    }

    .p-highlight .p-tabview-title {
        color: ${({ tabFontColor }) => tabFontColor ? tabFontColor : TITLE_FONT_COLOR};
    }

    .p-highlight {
        background: none !important;
        border-bottom: ${({ isCondensedView }) =>
        isCondensedView ? 'none' : `3px solid ${TITLE_FONT_COLOR}`};
    }

    .p-tabview-nav-link {
        border: none !important;
        box-shadow: none !important;
    }

    .p-tabview-panels {
        padding: 0 !important;
        width: 100% !important;
        background: none;
    }

    .p-tabview-nav li.p-highlight a,
    .p-tabview-nav li.p-highlight .p-tabview-nav-link {
        background-color: ${({ activeBGColor }) =>
            activeBGColor ? activeBGColor : `${WHITE_FONT_COLOR} !important`};
    }
`;

export const StyledTab = styled(TabPanel)`
    padding: 0 !important;
    width: 100% !important;
`;
